import { Alert } from "antd";
import React from "react";

const CustomAlert = ({ message, type }) => {
	return <Alert message={message} type={type} showIcon />;
};

export default CustomAlert;
